import compact from 'lodash/compact';
import isBoolean from 'lodash/isBoolean';
import over from 'lodash/over';

export const combineMixins = (mixins = []) => ((props) => compact(over(mixins)(props)).join(' '));

export const deriveValueFromProp = (value, defaultValue) => {
  return isBoolean(value) ? defaultValue : value;
};
